import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { installErrorReporting } from './lib/report';
import { bootTelegram } from './lib/tg';
import './styles/tokens.css';
import './styles/base.css';
import './styles/app.css';
import './styles/journey.css';
import './styles/desktop.css';

// Synchronous, local, never throws: reads launch params and tells Telegram we're ready.
installErrorReporting();
bootTelegram();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
